import dayjs from "dayjs";
import { buildDayjs } from "@metriport/shared/common/date";

export const ISO_DATE = "YYYY-MM-DD";
const DATETIME_FORMAT = "MMM D, YYYY h:mm A";
const DATETIME_NO_YEAR_FORMAT = "MMM D, h:mm A";

export const formatDateTime = (date: Date | null | undefined): string => {
  if (!date) return "-";
  return buildDayjs(date).format(DATETIME_FORMAT);
};

export const formatDateTimeInLocal = (date: Date | null | undefined): string => {
  if (!date) return "-";
  return dayjs(date).format(DATETIME_FORMAT);
};

export const formatDateTimeInLocalNoYear = (date: Date | null | undefined): string => {
  if (!date) return "-";
  return dayjs(date).format(DATETIME_NO_YEAR_FORMAT);
};
